import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './Inspection.module.scss';
import { loader } from 'graphql.macro';
import { Text } from '../../components/typography';
import { NetworkStatus, useMutation, useQuery } from '@apollo/client';
import { Spinner } from 'react-bootstrap';
import Accordian from '../../components/Accordian';
import InspectionItemText from '../../components/inspections/inspection_items/InspectionItemText';
import { defaultNavbarState, navbarVar } from '../../graphql/cache/navbar';
import Button from '../../components/Button';
import {
  alertVar,
  openAnalysisModal,
  showToast,
} from '../../graphql/cache/modal';
import { toastVariant, toastLength } from '../../constants/misc';
import RightSidebar from './RightSidebar';
import { Icon } from '@mui/material';
import classNames from 'classnames';
import { useWorkspace } from '../../providers/WorkspaceProvider';
import { paths } from '../../constants/strings';
import AssessmentAnalysisCard from '../../components/machine_learning/AssessmentAnalysisCard';
import {
  hasObservations,
  noObservations,
} from '../../components/machine_learning/riskAnalysis';
import { getRoute } from '../../constants/strings';
import { useInspection } from '../../hooks/offline-hooks/createInspectionhook';
import { useOnlineStatus } from '../../hooks/offline-hooks/offline-misc';
import { useCurrentUser } from '../../providers/UserProvider';
import { useTranslation } from 'react-i18next';
import {
  keys,
  getTranslationKey,
} from '../../utilities/translator/translation_keys.js';
import { isValidUUID } from '../../utilities/offline_hooks_setup_apollo/offlineUtils.js';
import { useModal } from '../../providers/ModalProvider.jsx';
import {
  evaluateCondition,
  formatBundleItems,
  hideLegacyMeetingFields,
  getCategoryConditionalTriggers,
  isCategoryVisible as checkCategoryVisible,
  getPrefillTriggers,
  getPrefillCandidatesForQuestion,
} from '../../utilities/inspection.js';
import { prefillTargetTypes } from '../../components/question_menu/conditionalActions/prefillTargetTypes';
import ReviewFooter from './ReviewFooter/ReviewFooter.jsx';
import { useTemplates } from '../../providers/TemplateProvider.jsx';
import InspectionItemAsset from '../../components/inspections/inspection_items/InspectionItemAsset.jsx';
import SimpleUserCard from '../../components/SimpleUserCard.jsx';
import { getLocalTime, monthSelector } from '../../utilities/time.js';
import Label from '../../components/action_items/Label.jsx';
import {
  cpaKeys,
  cpaStatusTypes,
  riskLevels,
  summaryStringLookup,
} from '../../utilities/audits.js';
import QuickFileDropzone from '../../components/image_uploads/QuickFileDropzone.jsx';
import { customColors } from '../../utilities/misc.js';
import TextWithIcon from '../../components/typography/TextWithIcon.jsx';
import Select from 'react-select';
import InspectionSignatures from './InspectionSignatures.jsx';
import SignatureCanvas from '../../components/SignatureCanvas.jsx';
import Notes from '../../components/notes/Notes.jsx';
import ConditionalInspectionItem from '../../components/inspections/inspection_items/ConditionalInspectionItem.jsx';
import { actionsKeys } from '../../components/question_menu/conditionalActions/conditionalAction.utils.js';
import { Form } from 'react-bootstrap';
import { downloadPDF } from '../../utilities/pdf_export/misc.js';
import InspectionIncidentHeader from './InspectionIncidentHeader.jsx';
import ActionItemCard from '../../components/action_items/ActionItemCard.jsx';
import { useActionItemModal, useMobileListener } from '../../hooks/misc.js';
import InspectionMeetingHeader from './InspectionMeetingHeader.jsx';
import { useVoiceRecorder } from '../../providers/VoiceRecorderProvider.jsx';
import { modals } from '../../providers/modals.js';
import { internalTypes } from '../../utilities/strings';
import DeletedReportPage from '../DeletedReportPage.jsx';
import SimpleFileCard from '../../components/files/SimpleFileCard.jsx';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useUserMutations } from '../../hooks/user/user_mutations.js';
import Spacer from '../../components/typography/Spacer.jsx';

const inspectionQuery = loader('./Inspection.inspection.graphql');
const publishMutation = loader('./Inspection.complete.graphql');
const CPAQuery = loader('../../pages/audit/CPATable.fetch.graphql');
const addInspectionAttachmentMutation = loader(
  './Inspection.addAttachment.graphql',
);
const updateInspectionMutation = loader('./Inspection.update.graphql');
const deleteInspectionAttachmentMutation = loader(
  './Inspection.deleteAttachment.graphql',
);
const addActionItemMutation = loader('./RightSidebar.addActionItem.graphql');
const actionItemsQuery = loader('./RightSidebar.fetchActionItems.graphql');
const inspectionCategoryStatusQuery = loader(
  './Inspection.fetchCatStatus.graphql',
);
const categoryReviewerQuery = loader('src/hooks/user/getReviewer.graphql');

const checkCategoryFailure = (category, itemMap) =>
  category.questions.some((question) => !!itemMap[question.id]?.failed);

const editableStatus = ['IN_PROGRESS', 'CHANGE_REQUEST'];

export default function Inspection() {
  const { id } = useParams();
  const { workspace } = useWorkspace();
  const { user: currentUser, isAdmin } = useCurrentUser();
  const isMilitary = currentUser?.timeSetting === 'military';
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [focusReviewers, setFocusReviewers] = useState(false);
  const { openConfirmationModal, openModal } = useModal();
  const [updateInspection] = useMutation(updateInspectionMutation);
  const [deleteAttachment] = useMutation(deleteInspectionAttachmentMutation);
  const [addActionItem] = useMutation(addActionItemMutation);
  const [addAttachment] = useMutation(addInspectionAttachmentMutation);
  // const [addParticipant] = useMutation(addParticipantMutation);
  const [loadingAttachment, setLoadingAttachment] = useState(false);
  const isMobile = useMobileListener();
  // const [addCategoryStatus] = useMutation(updateCategoryMutation);
  const { disableAssessmentSignature, disableAi, enableSapExport } = useFlags();

  const {
    completeInspection,
    updateBundle,
    removeBundle,
    updateInspectionUsage,
    addParticipant,
    addCategoryStatus,
  } = useInspection();
  useEffect(() => {
    navbarVar({ ...defaultNavbarState, showMenu: false });
  }, []);
  const [publishInspection] = useMutation(publishMutation);
  const online = useOnlineStatus();
  const { t } = useTranslation();
  const { allTemplates } = useTemplates();
  const inspectionId = parseInt(id);
  const [isEditingMonth, setIsEditingMonth] = useState(false);
  const [notes, setNotes] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const completeKey = t(keys.common.COMPLETE);
  const [expand, setExpand] = useState(true);
  const { openActionItemModal } = useActionItemModal();
  const [isEditingSubject, setIsEditingSubject] = useState(false);
  const inputRef = useRef(null);
  const [showComments, setShowComments] = useState(false);
  const [summaryPublished, setSummaryPublished] = useState(false);
  const [executiveSummary, setExecutiveSummary] = useState(null);
  const { addReviewer } = useUserMutations();

  const calculateRequiredProgress = (category, itemMap) => {
    let completed = 0;
    let total = category.questions.filter((q) => q.required)?.length;
    const isBundle = category.isBundle;

    if (isBundle) {
      let bundleMultiplier = 1;
      category.questions.forEach((question) => {
        if (itemMap[question.id]) {
          const numberOfBundles = itemMap[question.id]?.length || 1;
          bundleMultiplier = Math.max(bundleMultiplier, numberOfBundles);
        }
      });
      total *= bundleMultiplier;
    }

    category.questions.forEach((question) => {
      if (isBundle && !!itemMap[question.id]) {
        itemMap[question.id]?.forEach((b) => {
          if (!!b.value?.length && question.required) {
            completed += 1;
          }
        });
      } else if (
        !!itemMap[question.id] &&
        !!itemMap[question.id]?.value &&
        question.required
      ) {
        completed += 1;
      }
      if (Array.isArray(question?.conditionalAction)) {
        const matchingActions = question.conditionalAction
          .filter((ca) =>
            evaluateCondition(itemMap[question?.id]?.value, {
              inputType: question?.inputType,
              conditionalAction: ca,
            }),
          )
          .flatMap((ca) => ca.actions ?? []);
        for (const { actionable, action } of matchingActions) {
          if (action === actionsKeys.followUpQuestion && actionable?.required) {
            total += 1;
            if (!!itemMap[actionable?.id]) {
              completed += 1;
            }
          }
        }
      }
    });
    return completed === total;
  };

  const calculateCategoryProgress = (category, itemMap) => {
    let completed = 0;
    const hasMessageQuestion = category?.questions
      ?.map(({ inputType }) => inputType)
      ?.includes('MESSAGE');
    let total = hasMessageQuestion
      ? category?.questions?.filter(({ inputType }) => inputType !== 'MESSAGE')
          ?.length
      : category.questions.length;
    category.questions.forEach((question) => {
      if (!!itemMap[question.id] && itemMap[question.id]?.value !== '') {
        completed += 1;
      }
      if (Array.isArray(question?.conditionalAction)) {
        const matchingActions = question.conditionalAction
          .filter((ca) =>
            evaluateCondition(itemMap[question?.id]?.value, {
              inputType: question?.inputType,
              conditionalAction: ca,
            }),
          )
          .flatMap((ca) => ca.actions ?? []);
        for (const { actionable, action } of matchingActions) {
          if (action === actionsKeys.followUpQuestion) {
            total += 1;
            if (!!itemMap[actionable?.id]) {
              completed += 1;
            }
          }
        }
      }
    });
    return completed === total
      ? completeKey
      : `${
          !calculateRequiredProgress(category, itemMap) ? '* ' : ''
        }${completed} / ${total}`;
  };

  const {
    refetch: refetchStatus,
    data: { inspectionCategoryStatus: [catStatus] = [{}] } = {},
  } = useQuery(inspectionCategoryStatusQuery, {
    skip: online ? isNaN(id) : !isValidUUID(id) && isNaN(id),
    fetchPolicy: online ? 'network-only' : 'cache-only',
    variables: {
      options: {
        filters: [{ field: 'inspectionId', operator: 'eq', value: `${id}` }],
      },
    },
  });

  const {
    loading,
    networkStatus,
    refetch,
    stopPolling,
    startPolling,
    data: { inspections: [inspection] = [{}] } = {},
  } = useQuery(inspectionQuery, {
    skip: online ? isNaN(id) : !isValidUUID(id) && isNaN(id),
    fetchPolicy: online ? 'cache-and-network' : 'cache-only',
    nextFetchPolicy: online ? 'cache-first' : 'cache-only',
    onCompleted: (data) => {
      if (online) {
        const summary = data?.inspections?.[0]?.executiveSummary || {};
        if (!!summary) {
          setExecutiveSummary(summary);
          if (summary.PUBLISHED === true) {
            setSummaryPublished(true);
          }
        }
      }
    },
    variables: {
      options: {
        filters: [
          { field: 'id', value: `${id}`, operator: 'eq' },
          { field: 'isArchived', operator: 'eq', value: ['FALSE'] },
        ],
      },
    },
  });

  const [subject, setSubject] = useState(inspection?.subject);
  const { refetch: refetchActionItems, data: { actionItems = [] } = {} } =
    useQuery(actionItemsQuery, {
      skip: !inspection?.id || !online,
      variables: {
        inspectionId: `${inspection?.id}`,
      },
    });
  const template = useMemo(
    () => allTemplates?.find((t) => t.id === inspection?.template?.id),
    [allTemplates, inspection?.template?.id],
  );
  const assessment = useMemo(() => {
    if (!inspection?.template?.id) return null;

    if (!template) return null;
    return { ...inspection, template, actionItems };
  }, [inspection, template, actionItems]);

  const hasLockedCat = useMemo(() => {
    const categories = template?.categories || [];
    return categories?.some((c) => !!c.locked);
  }, [template?.categories]);

  const { refetch: refetchReviewers, data: { reviewers = [] } = {} } = useQuery(
    categoryReviewerQuery,
    {
      skip: !inspection?.id || !online || !hasLockedCat,
      variables: {
        options: {
          filters: [
            { field: 'parentId', operator: 'eq', value: `${inspection?.id}` },
          ],
        },
      },
    },
  );
  const isDraft = assessment?.isDraft || inspection?.isDraft;

  const stepState = useMemo(() => {
    const categories = template?.categories || [];
    if (!categories.length) {
      return {
        sorted: [],
        lastCompletedSortIndex: Number.NEGATIVE_INFINITY,
        nextLocked: undefined,
      };
    }
    const sorted = [...categories].sort((a, b) => a.sortIndex - b.sortIndex);
    const locked = online && isDraft ? sorted.filter((c) => !!c.locked) : [];
    const lastCompleted =
      catStatus?.categoryId && online
        ? sorted.find((c) => c.id === catStatus.categoryId)
        : undefined;
    const lastCompletedSortIndex =
      lastCompleted?.sortIndex ?? Number.NEGATIVE_INFINITY;
    const nextLocked = locked?.find(
      (c) => c.sortIndex > lastCompletedSortIndex,
    );

    return { sorted, lastCompletedSortIndex, nextLocked };
  }, [template?.categories, online, isDraft, catStatus?.categoryId]);

  const { itemMap, bundleMap } = useMemo(() => {
    let itemMap = {};
    let bundleMap = {};
    if (!assessment?.items) {
      return { bundleMap, itemMap };
    }
    return formatBundleItems(assessment.items);
  }, [assessment]);

  const categoryConditionalTriggers = useMemo(
    () => getCategoryConditionalTriggers(template?.categories),
    [template?.categories],
  );

  const isCategoryVisible = (category) =>
    checkCategoryVisible(category, categoryConditionalTriggers, itemMap);

  const prefillTriggers = useMemo(
    () =>
      getPrefillTriggers(
        template?.categories?.flatMap((c) => c.questions ?? []) ?? [],
      ),
    [template?.categories],
  );

  // Only questions whose inputType is registered in prefillTargetTypes ever get candidates —
  // everything else gets undefined and renders exactly as it did before this feature existed.
  const getPrefillCandidates = (question) => {
    const targetType = prefillTargetTypes[question.inputType];
    if (!targetType) return undefined;
    return getPrefillCandidatesForQuestion(
      question.id,
      prefillTriggers,
      itemMap,
    ).filter(
      (candidate) =>
        !targetType.isAlreadyApplied(
          itemMap[question.id]?.value,
          candidate,
          question,
        ),
    );
  };

  const { isRecording, setAudioURL } = useVoiceRecorder();

  const submitDisabled = useMemo(() => {
    if (isRecording) {
      return true;
    }
    return !assessment?.template?.categories?.every((category) => {
      if (!isCategoryVisible(category)) return true;
      return calculateRequiredProgress(category, itemMap);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    assessment?.template?.categories,
    isRecording,
    itemMap,
    categoryConditionalTriggers,
  ]);

  const isAudit = assessment?.inspectionType === 'AUDIT';
  const isMeeting = assessment?.inspectionType === 'MEETING';

  const {
    refetch: refetchCPA,
    data: { correctiveActions = [], correctiveActionCount = 0 } = {},
  } = useQuery(CPAQuery, {
    skip: !isAudit || !id || !online,
    variables: {
      options: {
        filters: [{ field: 'inspectionId', operator: 'eq', value: [`${id}`] }],
      },
    },
  });

  const submitToast = () => {
    setTimeout(() => {
      showToast({
        title: t(keys.action.COMPLETED, {
          variable:
            assessment.inspectionType === 'VEHICLE'
              ? t(keys.common.INSPECTION)
              : t(keys.common.REPORT),
        }),
        message: t(keys.assessments.SUBMITTED_MESSAGE, {
          variable:
            assessment.inspectionType === 'VEHICLE'
              ? t(keys.common.INSPECTION)
              : t(keys.common.REPORT),
        }),
        variant: toastVariant.info,
        time: toastLength.md,
      });
    }, 1000);
  };
  const isLoading =
    networkStatus === NetworkStatus.loading ||
    (!!inspection?.template?.id && !template);

  const { vehicle, attachments } = inspection || {};

  const missingSignatures = useMemo(() => {
    const { participantSignatureRequired, disableSignatureBox } =
      assessment?.template?.templateOptions || {};
    if (
      !participantSignatureRequired ||
      disableSignatureBox ||
      disableAssessmentSignature
    ) {
      return [];
    }
    const signedIds = new Set(
      attachments
        ?.filter((a) => a.extension === 'SIGNATURE')
        .map((a) => a.creator?.id),
    );
    return (
      assessment?.participants?.filter(
        (p) => p.active && !signedIds.has(p.id),
      ) ?? []
    );
  }, [assessment, attachments, disableAssessmentSignature]);

  const handleMonthChange = (newMonth) => {
    const parts = inspection.documentNumber.split('-');
    const dateParts = parts.slice(-3);
    dateParts[0] = newMonth.value;
    const documentNumber = [...parts.slice(0, -3), ...dateParts].join('-');
    updateInspection({
      variables: {
        id: inspection.id,
        documentNumber,
      },
    }).then(() => setIsEditingMonth(false));
  };

  const isIncident = inspection?.inspectionType === 'INCIDENT';
  const refImageCount = inspection?.template?.images?.length || 0;

  const inspectionFiles = useMemo(() => {
    return (
      attachments?.filter(
        (f) => f.extension !== 'SIGNATURE' && f.fileType !== 'AUDIO',
      ) || []
    );
  }, [attachments]);

  const showActionItems = useMemo(() => {
    if (!expand) {
      return false;
    }
    if (isDraft) {
      return true;
    }
    return !!correctiveActionCount || !!actionItems?.length;
  }, [actionItems?.length, correctiveActionCount, expand, isDraft]);

  const [selectedOption, setSelectedOption] = useState('Open');

  const actionItemDisplay = useMemo(() => {
    const data = isAudit ? correctiveActions : actionItems;
    const closedStatuses = ['DONE', 'COMPLETE', 'DUPLICATE'];
    if (selectedOption === 'Open') {
      return data?.filter((d) => !closedStatuses.includes(d.status));
    }
    return data?.filter((d) => closedStatuses.includes(d.status));
  }, [actionItems, correctiveActions, isAudit, selectedOption]);

  //eslint-disable-next-line
  const [isPrivate, setIsPrivate] = useState(assessment?.private);
  //eslint-disable-next-line
  const [allWorkspaces, setAllWorkspaces] = useState(!!inspection?.workspaceId);

  useEffect(() => {
    if (!!inspection?.workspaceId) {
      setAllWorkspaces(false);
    } else {
      setAllWorkspaces(true);
    }
  }, [inspection?.workspaceId]);

  useEffect(() => {
    if (
      !!assessment?.id &&
      !!assessment?.template?.id &&
      assessment?.private === true
    ) {
      setIsPrivate(true);
    }
  }, [assessment]);

  const openClosedMenu = (
    <div className={styles.flex} style={{ marginBottom: '0.5rem' }}>
      <Text
        weight={selectedOption === 'Open' ? 'bold' : 'regular'}
        color="accentPrimary"
        noMargin
        hover
        size="sm"
        onClick={() => setSelectedOption('Open')}
      >
        Open
      </Text>
      <Text
        weight={selectedOption === 'Closed' ? 'bold' : 'regular'}
        color="accentPrimary"
        noMargin
        hover
        size="sm"
        onClick={() => setSelectedOption('Closed')}
      >
        Closed
      </Text>
    </div>
  );

  const isCreator = inspection?.creator?.id === currentUser.id;

  const showSecondSight = useMemo(() => {
    if (disableAi) return;
    if (isAudit || isMeeting) {
      return false;
    } else if (!isDraft && !!assessment?.riskAnalysis) {
      return true;
    }
    return false;
  }, [assessment?.riskAnalysis, isAudit, isDraft, isMeeting, disableAi]);

  useEffect(() => {
    if (!!isEditingSubject && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditingSubject]);

  useEffect(() => {
    if (online) startPolling(5000);
    return () => stopPolling();
  }, [startPolling, stopPolling, online]);

  // In-progress recorded meetings are worked on in the meeting modal, not here
  const isRecordedMeetingDraft =
    online &&
    !!assessment?.isDraft &&
    assessment?.template?.internalType === internalTypes.recordedMeeting;

  useEffect(() => {
    if (!isRecordedMeetingDraft) return;
    openModal({
      modalName: modals.recordMeeting,
      variables: { inspectionId: assessment.id },
    });
    navigate(getRoute(workspace?.id, paths.dashboard), { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRecordedMeetingDraft]);

  const conditionalAction = useMemo(
    () => assessment?.template?.conditionalAction,
    [assessment],
  );

  // eslint-disable-next-line
  const [showConditionalActions, setShowConditionalActions] = useState(true);
  const categoryUsers = useMemo(() => {
    if (
      !Array.isArray(assessment?.template?.categories) ||
      !Array.isArray(inspection?.items)
    )
      return [];
    let users = [];
    for (const item of inspection?.items) {
      if (!!item?.users?.length) {
        users.push(item.users);
      }
      if (!!item?.user) {
        users.push(item.user);
      }
    }
    const result = users?.flat() || {};
    return result;
  }, [assessment?.template?.categories, inspection?.items]);

  return online &&
    !loading &&
    !inspection?.id &&
    !assessment?.template?.id &&
    !isLoading ? (
    <DeletedReportPage />
  ) : !!assessment?.template?.id ? (
    <div className={styles.split}>
      <div
        className={classNames([styles.container, sidebarOpen && styles.hide])}
      >
        <div>
          {isIncident && !!inspection.incident?.id ? (
            <InspectionIncidentHeader incident={inspection?.incident} />
          ) : null}
          <div className={styles.header}>
            <div className={styles.flex}>
              <Text noMargin weight="bold" size="md-lg">
                {`${assessment?.template?.title}`}
                <span className={styles.span}>
                  {`${
                    assessment?.template?.revisionNumber
                      ? ` (Rev ${assessment.template.revisionNumber})`
                      : ''
                  }
                  `}
                </span>
              </Text>
              {(isAdmin || isCreator) &&
                isDraft &&
                !isEditingSubject &&
                online && (
                  <Icon
                    baseClassName="material-icons-outlined"
                    sx={{
                      fontSize: '1.3rem',
                      opacity: 0.8,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setIsEditingSubject(!isEditingSubject);
                      setSubject(inspection.subject);
                    }}
                  >
                    edit
                  </Icon>
                )}
            </div>
            <div className={styles.rightTitle}>
              <Text noMargin weight="bold" size="md-lg" textAlign="right">
                {vehicle?.unitNumber}
              </Text>
            </div>
            <div
              onClick={() => {
                setSidebarOpen(true);
              }}
              className={classNames([styles.hideDesktop])}
            >
              <Icon baseClassName="material-icons-outlined">more_horiz</Icon>
            </div>
          </div>
          <div className={styles.flex}>
            {isEditingSubject ? (
              <div className={styles.fullWidth}>
                <Form.Control
                  ref={inputRef}
                  className={styles.fullWidth}
                  value={subject}
                  placeholder="Enter Document Subject"
                  onChange={(e) => setSubject(e.target.value)}
                  onBlur={() => {
                    if (!!subject && isEditingSubject) {
                      updateInspection({
                        variables: { id: inspection.id, subject },
                      });
                    } else if (!subject && isEditingSubject) {
                      updateInspection({
                        variables: { id: inspection.id, subject: null },
                      });
                    }
                    setIsEditingSubject(false);
                  }}
                />
              </div>
            ) : !!assessment?.subject ? (
              <Text weight="semiBold" noMargin>
                {assessment?.subject}
              </Text>
            ) : null}
          </div>
          {!!inspection?.documentNumber && (
            <>
              <div className={styles.flex}>
                <Text color="secondary" size="sm" weight="semiBold" noMargin>
                  {`${t(keys.assessments.DOCUMENT_NUMBER)}: ${
                    inspection?.documentNumber
                  }`}
                </Text>
                {inspection?.documentNumber?.split('-')?.length >= 4 &&
                inspection.isDraft &&
                isAdmin &&
                online ? (
                  isEditingMonth ? (
                    <Select
                      placeholder={'Select Month'}
                      options={monthSelector}
                      onChange={(value) => handleMonthChange(value)}
                    />
                  ) : (
                    <Icon
                      baseClassName="material-icons-outlined"
                      onClick={() => setIsEditingMonth(true)}
                      sx={{
                        fontSize: '1rem',
                        opacity: 0.8,
                        cursor: 'pointer',
                      }}
                    >
                      edit
                    </Icon>
                  )
                ) : null}
              </div>
              {isNaN(inspection?.id) && (
                <Text noMargin color="secondary" size="sm">
                  {t(keys.assessments.DOCUMENT_NUMBER_DISCLAIMER)}
                </Text>
              )}
            </>
          )}

          <Text color="secondary" weight="semiBold" noMargin>
            {assessment?.template?.description}
          </Text>
          {!!vehicle ? (
            <div className={styles.vehicleCard}>
              <InspectionItemAsset
                vehicle={{
                  ...vehicle,
                  odometer: inspection.odometer || vehicle.odometer,
                  hours: inspection.hours || vehicle.hours,
                }}
                size="lg"
                variant="header"
                readOnly={assessment?.status !== 'IN_PROGRESS'}
                disableDirectWrite
                onChange={(newValues) => {
                  const { trackingType = '', isMetric } = vehicle;

                  const valueMap = {
                    distance: 'odometer',
                    time: 'hours',
                  };

                  const rangeMap = {
                    distance: isMetric ? 700 : 700 * 0.621371,
                    time: 24,
                  };

                  const originalValue = vehicle[valueMap[trackingType]];
                  const newValue = newValues[valueMap[trackingType]];

                  if (
                    !!vehicle?.usageUpdateRequired &&
                    (newValue - originalValue > rangeMap[trackingType] ||
                      newValue < originalValue ||
                      newValue === originalValue)
                  ) {
                    openConfirmationModal({
                      title: 'Warning',
                      variant: 'warning',
                      description:
                        newValue === originalValue
                          ? "You've entered no change for this asset. Are you confirming this asset was not used? Have you updated the status?"
                          : 'The number you entered is out of range for an typical value. Are you sure it is correct?',
                      onSubmit: () =>
                        updateInspectionUsage({
                          ...newValues,
                          assetId: vehicle?.id,
                          inspectionId: inspection.id,
                          hours:
                            newValues?.hours ||
                            vehicle.hours ||
                            inspection.hours,
                          odometer:
                            newValues?.odometer ||
                            vehicle.odometer ||
                            inspection.odometer,
                        }),
                    });
                  } else {
                    updateInspectionUsage({
                      ...newValues,
                      assetId: vehicle?.id,
                      inspectionId: inspection.id,
                      hours:
                        newValues?.hours || vehicle.hours || inspection.hours,
                      odometer:
                        newValues?.odometer ||
                        vehicle.odometer ||
                        inspection.odometer,
                    });
                  }
                }}
              />
            </div>
          ) : null}
          <div>
            <div className={styles.marginLeft}>
              <div className={styles.flexRow}>
                <TextWithIcon
                  hover
                  weight="semiBold"
                  color="accentPrimary"
                  textAlign="right"
                  icon={showComments ? 'expand_less' : 'expand_more'}
                  size="sm"
                  noMargin
                  className={styles.selectorText}
                  onClick={() => setShowComments(!showComments)}
                >
                  {!showComments ? 'SHOW COMMENTS' : 'HIDE COMMENTS'}
                </TextWithIcon>
                <TextWithIcon
                  hover
                  weight="semiBold"
                  color="accentPrimary"
                  textAlign="right"
                  icon={expand ? 'expand_less' : 'expand_more'}
                  size="sm"
                  noMargin
                  className={styles.selectorText}
                  onClick={() => setExpand(!expand)}
                >
                  {!expand ? 'SHOW CATEGORIES' : 'HIDE CATEGORIES'}
                </TextWithIcon>
              </div>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            {isMeeting ? (
              <InspectionMeetingHeader
                expand={expand}
                inspection={assessment}
                onComplete={() => {
                  setAudioURL(null);
                  refetch();
                }}
              />
            ) : null}
            {showSecondSight ? (
              <AssessmentAnalysisCard
                expand={expand}
                message={
                  assessment?.riskAnalysis
                    ? t(hasObservations.message)
                    : t(noObservations.message)
                }
                analysis={assessment?.riskAnalysis?.split('|') || null}
                disclaimer={
                  assessment?.riskAnalysis
                    ? t(hasObservations.disclaimer)
                    : t(noObservations.disclaimer)
                }
                inspectionId={assessment.id}
              />
            ) : null}
            {online && (
              <Accordian
                title={t(keys.common.REFERENCE_FILES)}
                expand={
                  !isDraft && !assessment?.template?.images?.length
                    ? false
                    : isDraft
                    ? true
                    : expand
                }
                size="md"
                accordianSize={true}
                icon="image"
                backgroundColor={customColors.DARK_GRAY}
                textColor="white"
                iconProps={{ color: 'white' }}
                messageVariant="white"
                message={refImageCount + inspectionFiles?.length}
              >
                {assessment?.template?.images?.length ? (
                  <div className={styles.referenceImages}>
                    {assessment.template.images.map((file) => (
                      <SimpleFileCard
                        key={`${file?.id}-template-file`}
                        readOnly
                        extension={file.extension}
                        fileName={file.name}
                        file={{ ...file, downloadAllowed: true }}
                      />
                    ))}
                  </div>
                ) : !inspection.isDraft ? (
                  <Text noMargin>{t(keys.common.NONE)}</Text>
                ) : null}

                {online ? (
                  <div className={styles.drop}>
                    <QuickFileDropzone
                      icon="true"
                      readOnly={!assessment.isDraft}
                      loading={loadingAttachment}
                      attachments={inspectionFiles}
                      setLoading={setLoadingAttachment}
                      onDelete={(id) => {
                        deleteAttachment({ variables: { id } }).then(() =>
                          refetch(),
                        );
                      }}
                      onSubmit={({ url, name, extension }) => {
                        addAttachment({
                          variables: {
                            url,
                            name,
                            extension,
                            inspectionId,
                          },
                        }).then(() => refetch());
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <br />
                    <Text
                      size="sm"
                      weight="semiBold"
                      color="secondary"
                      textAlign="center"
                    >
                      {t(keys.common.REFERENCE_FILES_OFFLINE)}
                    </Text>
                  </div>
                )}
              </Accordian>
            )}
            {stepState.sorted.map((category) => {
              if (!isCategoryVisible(category)) {
                return null;
              }
              const readOnly =
                category.sortIndex <= stepState.lastCompletedSortIndex - 10;
              const isNextLocked = stepState.nextLocked?.id === category.id;
              const reviewer = reviewers?.find(
                (r) => r.reviewableId === category.id,
              );
              if (isNextLocked && isDraft) {
                return (
                  <Button
                    key={`submit-${category.id}`}
                    disabled={!calculateRequiredProgress(category, itemMap)}
                    align="right"
                    value="Submit"
                    onClick={async () => {
                      openConfirmationModal({
                        title: t(keys.action.CONFIRM_CHANGES),
                        description: t(keys.action.PUBLISH_CONFIRMATION),
                        variant: 'warning',
                        textInput: true,
                        onSubmit: async (notes) => {
                          // Silent - they're told via the completion
                          // notification instead
                          for (const user of categoryUsers) {
                            await addParticipant({
                              userId: user.id,
                              inspectionId: inspection?.id,
                              notify: false,
                            });
                          }
                          await addCategoryStatus({
                            categoryId: category?.id,
                            inspectionId: inspection?.id,
                            status: 'COMPLETE',
                          });
                          await addReviewer({
                            userId: currentUser.id,
                            reviewableType: 'inspectionCategory',
                            reviewableId: category?.id,
                            status: 'COMPLETE',
                            parentId: inspection.id,
                            notes,
                          });
                          refetchStatus();
                          refetchReviewers();
                          refetch();
                        },
                      });
                    }}
                  />
                );
              }
              if (
                online &&
                stepState.nextLocked &&
                category.locked &&
                category.sortIndex > stepState.nextLocked.sortIndex
              ) {
                return null;
              }
              return (
                <div key={`category-${category.id}`}>
                  {!!reviewer?.id && online ? (
                    <div className={styles.catStatusContainer}>
                      <div className={styles.flexRowCenter}>
                        <TextWithIcon
                          leftIcon="check_circle"
                          noMargin
                          size="sm"
                          iconProps={{ color: customColors.GREEN }}
                        >{`${t(keys.common.COMPLETED)} ${getLocalTime(
                          reviewer.dateCreated,
                        ).format(
                          isMilitary
                            ? 'MMMM Do, YYYY HH:mm'
                            : 'MMMM Do, YYYY h:mma',
                        )}`}</TextWithIcon>
                        <div>
                          <SimpleUserCard
                            mediumAvatar
                            user={reviewer.user}
                            size="sm"
                            weight="regular"
                          />
                        </div>
                      </div>
                      {reviewer?.notes ? (
                        <Text textAlign="center" noMargin>
                          {reviewer?.notes}
                        </Text>
                      ) : null}
                    </div>
                  ) : null}
                  <div>
                    <Accordian
                      readOnly={readOnly}
                      expand={expand}
                      isBundle={category?.isBundle}
                      icon={category.isBundle ? 'layers' : null}
                      iconProps={{
                        color: '#0d6efd',
                        outlined: true,
                        position: 'right',
                      }}
                      title={
                        !!assessment.template.internalType
                          ? t(getTranslationKey(category.title, 'assessments'))
                          : category.title
                      }
                      messageVariant={
                        checkCategoryFailure(category, itemMap)
                          ? 'red'
                          : 'primary'
                      }
                      message={
                        readOnly
                          ? t(keys.common.COMPLETE)
                          : calculateCategoryProgress(category, itemMap)
                      }
                    >
                      {category.isBundle
                        ? !!bundleMap[category.id] &&
                          Object.entries(bundleMap[category.id]).map(
                            ([bundleId, answers], idx) => {
                              const singleQuestion =
                                Object.entries(bundleMap[category.id])
                                  .length === 1;

                              const questionIds = Object.keys(answers).map(
                                (i) => parseInt(i),
                              );

                              const questions = [];

                              questionIds.forEach((q) =>
                                questions.push(
                                  category.questions.find(({ id }) => id === q),
                                ),
                              );

                              return (
                                <div
                                  key={`bundle-${bundleId}`}
                                  className={styles.bundleContainer}
                                >
                                  <Text
                                    noMargin
                                    weight="semiBold"
                                    className={styles.bundleNumber}
                                  >{`${idx + 1}. `}</Text>
                                  <div
                                    className={
                                      idx % 2 !== 0
                                        ? styles.oddBundle
                                        : styles.evenBundle
                                    }
                                  >
                                    {questions
                                      .sort(
                                        (a, b) => a?.sortIndex - b?.sortIndex,
                                      )
                                      .map((question) => {
                                        const item = answers[question?.id];

                                        if (!item) return null;

                                        return (
                                          <div
                                            key={`bundle-answer-${item.id}`}
                                            className={styles.bundleQuestion}
                                          >
                                            <InspectionItemText
                                              showAllComments={showComments}
                                              onCommentIconClick={() =>
                                                setShowComments(false)
                                              }
                                              readOnly={
                                                readOnly ||
                                                assessment.status !==
                                                  'IN_PROGRESS'
                                              }
                                              refetchActionItems={
                                                refetchActionItems
                                              }
                                              refetchCPA={refetchCPA}
                                              questionId={question.id}
                                              inspectionId={assessment.id}
                                              cpas={correctiveActions || []}
                                              inspectionVehicleId={
                                                item?.vehicle?.id ??
                                                assessment.vehicle?.id
                                              }
                                              vehicleUnitNumber={
                                                assessment.vehicle?.unitNumber
                                              }
                                              inspectionType={
                                                assessment.inspectionType
                                              }
                                              title={question.title}
                                              description={question.description}
                                              item={item}
                                              additionalData={
                                                question.additionalData
                                              }
                                              inspectionQuery={inspectionQuery}
                                              required={question.required}
                                              inputType={question.inputType}
                                              inspectionTitle={
                                                assessment.template.title
                                              }
                                              workspaceId={workspace?.id}
                                              internalType={
                                                assessment.template.internalType
                                              }
                                              refetch={refetch}
                                              isBundle={category.isBundle}
                                              inspection={assessment}
                                              question={question}
                                            />
                                            <ConditionalInspectionItem
                                              item={item}
                                              question={question}
                                              assessment={assessment}
                                              workspace={workspace}
                                              correctiveActions={
                                                correctiveActions || []
                                              }
                                            />
                                          </div>
                                        );
                                      })}
                                    {isDraft && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'flex-end',
                                          width: '100%',
                                        }}
                                      >
                                        <Icon
                                          className={
                                            singleQuestion
                                              ? styles.disabled
                                              : styles.deleteIcon
                                          }
                                          sx={{
                                            fontSize: '1.2rem',
                                          }}
                                          onClick={() => {
                                            if (!singleQuestion)
                                              openConfirmationModal({
                                                title: t(
                                                  keys.action.DELETE_VARIABLE,
                                                  {
                                                    variable: t(
                                                      keys.assessments.BUNDLE,
                                                    ),
                                                  },
                                                ),
                                                description: t(
                                                  keys.action
                                                    .DELETE_CONFIRMATION,
                                                  {
                                                    variable: t(
                                                      keys.assessments.BUNDLE,
                                                    ),
                                                  },
                                                ),
                                                variant: 'danger',
                                                confirmText: t(
                                                  keys.action.DELETE,
                                                ),
                                                onSubmit: () => {
                                                  removeBundle({
                                                    inspectionId: assessment.id,
                                                    bundleId,
                                                  });
                                                },
                                              });
                                          }}
                                        >
                                          delete_outlined
                                        </Icon>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            },
                          )
                        : category.questions.map((question, idx) => {
                            const isRecordedMeeting =
                              assessment.template.internalType ===
                              'RECORDED_MEETING';
                            const isInternalField =
                              hideLegacyMeetingFields.includes(question.title);
                            const noValue = !question.value;
                            if (
                              isRecordedMeeting &&
                              isInternalField &&
                              noValue
                            ) {
                              return null;
                            }
                            return (
                              <div
                                key={`question-${question.id}`}
                                className={
                                  idx % 2 !== 0 ? styles.odd : styles.even
                                }
                              >
                                <InspectionItemText
                                  onCommentIconClick={() =>
                                    setShowComments(false)
                                  }
                                  showAllComments={showComments}
                                  refetchActionItems={refetchActionItems}
                                  refetchCPA={refetchCPA}
                                  questionId={question.id}
                                  prefillCandidates={getPrefillCandidates(
                                    question,
                                  )}
                                  inspectionId={assessment.id}
                                  inspectionVehicleId={
                                    itemMap[question?.id]?.vehicle?.id ??
                                    assessment.vehicle?.id
                                  }
                                  onEdit={setIsEditing}
                                  vehicleUnitNumber={
                                    assessment.vehicle?.unitNumber
                                  }
                                  inspectionType={assessment.inspectionType}
                                  title={question.title}
                                  description={question.description}
                                  item={itemMap[question.id]}
                                  additionalData={question.additionalData}
                                  inspectionQuery={inspectionQuery}
                                  required={question.required}
                                  inputType={question.inputType}
                                  inspectionTitle={assessment.template.title}
                                  workspaceId={workspace?.id}
                                  internalType={
                                    assessment.template.internalType
                                  }
                                  readOnly={
                                    readOnly ||
                                    !editableStatus.includes(assessment?.status)
                                  }
                                  refetch={refetch}
                                  inspection={assessment}
                                  cpas={correctiveActions || []}
                                  question={question}
                                />
                                <ConditionalInspectionItem
                                  item={itemMap[question.id]}
                                  question={question}
                                  assessment={assessment}
                                  workspace={workspace}
                                  correctiveActions={correctiveActions || []}
                                />
                              </div>
                            );
                          })}
                      {category.isBundle && isDraft && (
                        <div className={styles.bundleButtons}>
                          <Button
                            outlined
                            onClick={() => {
                              const items = [];
                              category.questions.forEach((question) => {
                                items.push(itemMap[question.id]);
                              });
                              updateBundle({
                                inspectionId: assessment.id,
                                categoryId: category.id,
                                questions: category.questions,
                              });
                            }}
                            icon={'layers'}
                            value={t(keys.assessments.ADD_QUESTIONS)}
                          />
                        </div>
                      )}
                    </Accordian>
                  </div>
                </div>
              );
            })}
            {isAudit ? (
              <Accordian
                expand={expand}
                size="md"
                accordianSize={true}
                backgroundColor={customColors.DARK_GRAY}
                textColor="white"
                iconProps={{ color: 'white' }}
                title="Executive Summary"
                icon="work"
                message={summaryPublished ? 'Complete' : 'Draft'}
              >
                {Object.entries(summaryStringLookup).map(([key, value]) => (
                  <div key={key} className={styles.paddingSm}>
                    <Text noMargin weight="bold">
                      {value}
                    </Text>
                    <div className={styles.spacer} />
                    {!summaryPublished ? (
                      <Form.Control
                        value={executiveSummary?.[key]}
                        as="textarea"
                        rows={4}
                        onChange={(e) =>
                          setExecutiveSummary({
                            ...executiveSummary,
                            [key]: e.target.value,
                          })
                        }
                        onBlur={() =>
                          updateInspection({
                            variables: { id: inspectionId, executiveSummary },
                          })
                        }
                      />
                    ) : (
                      <Text noMargin prewrap>
                        {executiveSummary?.[key] || t(keys.common.NONE)}
                      </Text>
                    )}
                  </div>
                ))}
                <br />
                {!summaryPublished ? (
                  <Button
                    align="right"
                    value="Publish"
                    outlined
                    icon="check_circle"
                    variant="success"
                    onClick={() => {
                      const final = { ...executiveSummary, PUBLISHED: true };
                      openConfirmationModal({
                        title: 'Publish Executive Summary',
                        description:
                          'Are you sure you are ready to publish? This cannot be edited once submitted.',
                        variant: 'warning',
                        onSubmit: () => {
                          updateInspection({
                            variables: {
                              id: inspectionId,
                              executiveSummary: final,
                            },
                          }).then(() => setExecutiveSummary(final));
                        },
                      });
                    }}
                  />
                ) : (
                  <Button
                    align={'right'}
                    outlined
                    value="Executive Summary PDF"
                    icon="download"
                    onClick={() =>
                      downloadPDF({
                        summary: inspection,
                        company: currentUser.company,
                        correctiveActions,
                        showDetails: false,
                        timeSetting: currentUser?.timeSetting,
                        fileName: `${getLocalTime(
                          assessment.dateCreated,
                        ).format(
                          'MM-DD-YYYY',
                        )}_${assessment.template?.title.replace(' ', '_')}_${
                          assessment.id
                        }_executive_summary`,
                      })
                    }
                  />
                )}
              </Accordian>
            ) : null}
            {online && (
              <Accordian
                size="md"
                accordianSize={true}
                icon="warning"
                title={
                  isAudit
                    ? 'Corrective Preventative Actions'
                    : t(keys.common.ACTION_ITEMS)
                }
                message={isAudit ? correctiveActionCount : actionItems?.length}
                backgroundColor={customColors.RED_LIGHT}
                textColor="white"
                iconProps={{ color: 'white' }}
                messageVariant="white"
                expand={showActionItems}
              >
                <div className={styles.cpaList}>
                  {isAudit ? (
                    <>
                      <div>{openClosedMenu}</div>
                      {!!actionItemDisplay?.length
                        ? actionItemDisplay?.map(
                            (
                              {
                                assignee,
                                dateCreated,
                                question,
                                status,
                                id,
                                riskLevel,
                                externalId,
                              },
                              idx,
                            ) => (
                              <div
                                className={
                                  idx % 2 === 0 ? styles.cpa : styles.cpaOdd
                                }
                                onClick={() => navigate(`/${paths.cpa}/${id}`)}
                                key={id}
                              >
                                <div className={styles.cpaLeft}>
                                  <TextWithIcon
                                    weight="semiBold"
                                    color="accentPrimary"
                                    noMargin
                                    link
                                  >
                                    {externalId}
                                  </TextWithIcon>
                                  <Text noMargin weight="semiBold" size="sm">
                                    {question?.title}
                                  </Text>
                                  <div className={styles.cpaHeader}>
                                    <Label
                                      rowSized={false}
                                      name={
                                        riskLevel
                                          ? `${cpaKeys[
                                              riskLevel
                                            ]?.toUpperCase()} `
                                          : null
                                      }
                                      color={
                                        riskLevels[riskLevel]?.color ||
                                        'primary'
                                      }
                                    />
                                    <Label
                                      rowSized={false}
                                      name={cpaStatusTypes[status]?.title}
                                      color={cpaStatusTypes[status]?.color}
                                    />
                                  </div>
                                </div>
                                <div>
                                  <SimpleUserCard
                                    largeAvatar
                                    user={assignee}
                                    smallText={getLocalTime(dateCreated).format(
                                      'ddd MMM DD YYYY HH:mm:ss',
                                    )}
                                  />
                                </div>
                              </div>
                            ),
                          )
                        : null}
                    </>
                  ) : (
                    <div>
                      {online && (
                        <div className={styles.header}>
                          {inspection.isDraft ? (
                            <TextWithIcon
                              hover
                              size="sm"
                              icon="add"
                              iconProps={{
                                color: customColors.BLUE,
                                fontSize: '1.2rem',
                              }}
                              noMargin
                              onClick={() => {
                                addActionItem({
                                  variables: {
                                    title: inspection?.template?.title,
                                    description: '',
                                    type: inspection.inspectionType,
                                    inspectionId: inspection.id,
                                    vehicleId: inspection.vehicle?.id,
                                    workspaceId: workspace?.id,
                                    private: !enableSapExport, // this will make the action items public for vale
                                  },
                                }).then(
                                  ({
                                    data: {
                                      addActionItem: { id },
                                    },
                                  }) => {
                                    openActionItemModal(
                                      id,
                                      'VEHICLE',
                                      refetchActionItems,
                                      true, // fromInspection prop to trigger editing description
                                    );
                                  },
                                );
                              }}
                            >
                              Add Action Item
                            </TextWithIcon>
                          ) : null}
                          {openClosedMenu}
                        </div>
                      )}
                      {actionItemDisplay?.length > 0 ? (
                        actionItemDisplay?.map((actionItem) => {
                          return (
                            <ActionItemCard
                              showName={true}
                              key={actionItem.id}
                              onClick={() =>
                                openActionItemModal(
                                  actionItem.id,
                                  null,
                                  refetchActionItems,
                                )
                              }
                              className={styles.actionItemCard}
                              actionItem={actionItem}
                              boxShadow={false}
                            />
                          );
                        })
                      ) : inspection.status !== 'IN_PROGRESS' ? (
                        <div>
                          <Spacer />
                          <Text noMargin color="secondary">
                            {t(keys.common.NONE)}
                          </Text>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </Accordian>
            )}
            {online && (
              <Accordian
                message={notes?.length || 0}
                expand={isAudit ? isDraft || notes?.length > 0 : expand}
                title={t(keys.common.NOTES)}
                icon="text_snippet"
                size="md"
                accordianSize={true}
                backgroundColor={customColors.DARK_GRAY}
                textColor="white"
                iconProps={{ color: 'white' }}
              >
                <Notes
                  parentId={inspectionId}
                  type={inspection.__typename}
                  setNotes={setNotes}
                />
                {!isMeeting && !!inspection?.notes && (
                  <Text noMargin>{inspection.notes}</Text>
                )}
              </Accordian>
            )}
            {online &&
            !disableAssessmentSignature &&
            !assessment?.template?.templateOptions?.disableSignatureBox ? (
              <Accordian
                message={
                  attachments?.filter((a) => a.extension === 'SIGNATURE')
                    ?.length
                }
                expand={
                  isAudit
                    ? isDraft ||
                      attachments?.filter((a) => a.extension === 'SIGNATURE')
                        ?.length > 0
                    : expand
                }
                title="Signatures"
                size="md"
                icon="draw"
                accordianSize={true}
                backgroundColor={customColors.DARK_GRAY}
                textColor="white"
                iconProps={{ color: 'white' }}
              >
                <div className={styles.sigInput}>
                  <SignatureCanvas
                    onSubmit={(url, failed, pass, name) => {
                      addAttachment({
                        variables: {
                          url,
                          inspectionId: inspection.id,
                          name,
                          extension: 'SIGNATURE',
                        },
                      }).then(() => refetch());
                    }}
                  />
                </div>
                <br />
                <InspectionSignatures
                  attachments={attachments}
                  currentUserId={currentUser.id}
                  onDelete={(id) =>
                    deleteAttachment({ variables: { id } }).then(() =>
                      refetch(),
                    )
                  }
                />
              </Accordian>
            ) : null}
            {conditionalAction?.length > 0 &&
              !assessment?.isDraft &&
              evaluateCondition(
                assessment.passed ? 'PASS' : 'FAIL',
                assessment.template,
              ) && (
                <Accordian
                  title={'Conditional Actions'}
                  expand={showConditionalActions}
                  size="md"
                  accordianSize={true}
                  icon="checklist"
                  backgroundColor={customColors.DARK_GRAY}
                  textColor="white"
                  iconProps={{ color: 'white' }}
                  messageVariant="white"
                  message={conditionalAction?.actions?.length}
                >
                  <ConditionalInspectionItem
                    item={{ value: assessment?.passed ? 'PASS' : 'FAIL' }}
                    question={assessment?.template}
                    assessment={assessment}
                    noTopMargin
                  />
                </Accordian>
              )}
            <div className={styles.bottomSpace} />
            {!inspection.isDraft && !inspection.reviewers?.length ? null : (
              <div className={styles.fixedFooter}>
                <ReviewFooter
                  refetch={refetch}
                  allQuestionsAnswered={!submitDisabled && !isEditing}
                  missingSignatures={missingSignatures}
                  inspection={assessment || []}
                  currentUser={currentUser}
                  publishInspection={() => {
                    publishInspection({
                      variables: {
                        id: assessment.id,
                      },
                    });
                  }}
                  onAddReviewers={
                    isMobile
                      ? () => {
                          setSidebarOpen(true);
                          setFocusReviewers(true);
                        }
                      : undefined
                  }
                  onSecondSight={(completedCallback) => {
                    openAnalysisModal({
                      inspection: assessment,
                      onSubmit: () => {
                        completedCallback();
                      },
                    });
                  }}
                  onComplete={() => {
                    let route = getRoute(workspace?.id, `${paths.assessments}`);
                    if (!online || isMobile) {
                      route = getRoute(workspace.id, paths.dashboard);
                    } else if (isAudit) {
                      route = `/${paths.audits}`;
                    } else if (!!assessment.incident?.id) {
                      route = `/${paths.incident}/${assessment.incident.id}?section=REPORTS`;
                    } else if (!!assessment.timecard?.id) {
                      route = `/${paths.timecard}/?id=${assessment.timecard.id}`;
                    } else if (assessment.inspectionType === 'INCIDENT') {
                      route = `/${paths.incidents}`;
                    } else if (
                      assessment?.inspectionType === 'QUALITY' ||
                      assessment?.inspectionType === 'MOC'
                    ) {
                      route = `/workspace/${workspace?.id}/quality`;
                    }

                    if (online && assessment?.template?.analysisRequested) {
                      openAnalysisModal({
                        inspection: assessment,
                        onSubmit: () => {
                          publishInspection({
                            variables: {
                              id: assessment.id,
                            },
                          }).then(() => {
                            alertVar({ ...alertVar(), show: false });
                            if (online) {
                              navigate(route);
                            }
                            submitToast();
                          });
                        },
                      });
                    } else {
                      openConfirmationModal({
                        title: isAudit
                          ? 'Finalize Audit'
                          : t(keys.action.CONFIRM_CHANGES),
                        description: isAudit
                          ? `Once you publish this audit, the changes will be locked in and can't be changed. Are you sure you want to publish?`
                          : t(keys.action.PUBLISH_CONFIRMATION),
                        variant: 'warning',
                        buttonText: t(keys.action.PUBLISH),
                        onSubmit: async () => {
                          // Silent and awaited - the audit closed
                          // notification goes to all participants once the
                          // audit is complete
                          for (const user of categoryUsers) {
                            await addParticipant({
                              userId: user.id,
                              inspectionId: assessment?.id,
                              notify: false,
                            });
                          }
                          completeInspection(assessment.id)
                            .then(() => {
                              alertVar({ ...alertVar(), show: false });
                              if (!assessment?.template?.conditionalAction) {
                                navigate(route);
                              } else {
                                const { actions } =
                                  assessment?.template?.conditionalAction ?? {};

                                const filteredActions = (actions ?? []).filter(
                                  (a) =>
                                    a.action !== actionsKeys.sendNotification,
                                );
                                if (
                                  filteredActions?.length > 0 &&
                                  evaluateCondition(
                                    assessment?.passed ? 'PASS' : 'FAIL',
                                    assessment?.template,
                                  )
                                ) {
                                  openModal({
                                    modalName: modals.conditionalAction,
                                    variables: {
                                      actions,
                                      workspaceId: assessment?.workspaceId,
                                      assessment,
                                      online,
                                    },
                                  });
                                }
                              }
                            })
                            .finally(() => submitToast());
                        },
                      });
                    }
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {!!inspection?.id && (
        <div className={styles.right}>
          <RightSidebar
            onClose={() => setSidebarOpen(false)}
            className={!sidebarOpen && styles.hide}
            focusReviewers={focusReviewers}
            onReviewersFocused={() => setFocusReviewers(false)}
            inspection={assessment}
            refetch={refetch}
            notes={notes}
            correctiveActions={correctiveActions || []}
            actionItems={actionItems || []}
            updateInspection={updateInspection}
          />
        </div>
      )}
    </div>
  ) : (
    <Spinner className={styles.spinner} animation="border" variant="primary" />
  );
}
